import { render, staticRenderFns } from "./NonCompliantProductModalOnTransitComponent.vue?vue&type=template&id=dd6a9d38"
import script from "./NonCompliantProductModalOnTransitComponent.vue?vue&type=script&lang=js"
export * from "./NonCompliantProductModalOnTransitComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports